import Checkbox from "@mui/material/Checkbox";
import { computed } from "mobx";
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from "react-router-dom";
import { useLeaseCompStore, usePipedriveStore } from '../..';
import useCircleWithRadius from '../../hooks/useCircleWithRadius';
import useCircleWithRadiusOnMap from "../../hooks/useCircleWithRadiusOnMap";
import useLeaseCompsWithFocusArea from "../../hooks/useLeaseCompsWithFocusArea";
import useLeaseCompsWithGlobalFilters from "../../hooks/useLeaseCompsWithGlobalFilters";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { formatNumber } from '../../utils/utils';
import LeaseCompsGrid from "../leaseComps/LeaseCompsGrid";
import RadiusDropdown from "../RadiusDropdown";
import Spinner from "../spinners/Spinner";

function DealDetailsLeaseCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const leaseCompStore = useLeaseCompStore();
    const pipedriveStore = usePipedriveStore();
    const deal = useMemo(() => computed(() => pipedriveStore.deals.find(d => d.id.toString() === id)!), [id]).get();
    const coordinates = useMemo(() => ({ latitude: deal.lat, longitude: deal.lon }), [deal]);
    const [radius, setRadius] = useState(5);
    const circle = useCircleWithRadius(coordinates, radius)!;
    useCircleWithRadiusOnMap(coordinates, radius, visible, "DealDetailsLeaseCompsTab");
    const leaseComps = useLeaseCompsWithFocusArea(useLeaseCompsWithGlobalFilters(
        useMemo(() => computed(() => leaseCompStore.leaseComps.filter(lc => circle.isPointInside(lc.centerPoint))), [circle]).get()
    ));

    useEffect(() => setEntityCount(leaseComps.length), [leaseComps]);

    if (!visible)
        return null;

    return (
        <LeaseCompsGrid
            leaseComps={leaseComps}
            additionalHeaders={[{
                titleStrings: ["DISTANCE"],
                getValue: item => circle!.getDistanceFromCenter(item.centerPoint),
                getLabel: item => {
                    const distance = circle!.getDistanceFromCenter(item.centerPoint);
                    return distance ? formatNumber(distance) : "";
                }
            }, {
                titleStrings: ["TAG"],
                getValue: item => deal.leaseCompIds.includes(item.id),
                getLabel: item => pipedriveStore.isDealsLoading.updating ? (
                    <Spinner />
                ) : (
                    <Checkbox
                        checked={deal.leaseCompIds.includes(item.id)}
                        onChange={() => pipedriveStore.updateTaggedLeaseComp(deal.id, item.id)}
                    />
                ),
                getStringLabel: item => deal.leaseCompIds.includes(item.id) ? "True" : "False",
                onClick: () => { }, // to prevent onRowClick
            }]}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(DealDetailsLeaseCompsTab);